import React from "react";
import PageHeader from "../PageHeader";
import Faqs from "../Faqs";
import heroBackImage from "../images/hero/hero.webp";

const FaqPage = () => {
  const breadcrumbLinks = [
    { label: "الرئيسية", path: "/" },
    { label: "الأسئلة الشائعة", path: "/faq" },
  ];

  return (
    <>
      <PageHeader
        title="الأسئلة الشائعة"
        bgImage={heroBackImage}
        breadcrumbs={breadcrumbLinks}
      />

      <Faqs />
    </>
  );
};

export default FaqPage;

